import React from 'react';

import autoBind from 'react-autobind';
import imageSearch from "../tools/GoogleImageSearch.js"

// import other components within the same project here

import Localization from "../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Button, TextField, IconButton, Icon, Tooltip } from '@mui/material';
import Gallery from 'react-grid-gallery';

class GoogleImageSearchDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      searchText: "",
      resultText: "",
      images: [],
      searchOffset: 0,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false,
      searchText: "",
      resultText: "",
      images: [],
      searchOffset: 0,
    });
    this.state.open = false;
    this.state.searchText = "";
    this.state.resultText = "";
    this.state.images = [];
    this.state.searchOffset = 0;
  }

  searchTextChanged(e) {
    this.setState({ searchText: e.target.value });
    this.state.searchText = e.target.value;
  }

   handleSearchClicked() {
    this.setState({ searchOffset: 0 });
    this.state.searchOffset = 0;
    this.searchImage();
  }

  searchImage() {
    imageSearch(this.state.searchText, this.searchImageOK, this.state.searchOffset, 10).then(images => {
      this.searchImageOK(images)
    }).catch(err => {
      this.setState({ images: [], resultText: 'search failed' });
      this.state.images = [];
      this.state.resultText = 'search failed';
      console.error(err);
    });
  }

  handleSearchEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchClicked();
    }
  }

  searchImageOK(images) {
    let result = [];
    images.map( (image, i) => {
      result.push(
        {
          src: image.link,
          thumbnail: image.image.thumbnailLink,
          thumbnailWidth: image.image.thumbnailWidth,
          thumbnailHeight: image.image.thumbnailHeight,
          caption: image.title,
        }
      )
    });

    this.setState({ images: result });
    this.state.images = result;
  }

  previousPageClicked() {
    let offset = this.state.searchOffset;
    offset -= 10;
    if (offset < 0) {
      offset = 0;
    }
    this.setState({ searchOffset: offset });
    this.state.searchOffset = offset;
    this.searchImage();
  }

  nextPageClicked() {
    let offset = this.state.searchOffset;
    offset += 10;
    if (offset > 90) {
      offset = 90;
    }
    this.setState({ searchOffset: offset });
    this.state.searchOffset = offset;
    this.searchImage();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogTitle>{Localization.strings.SAFE_IMAGE_SEARCH}</DialogTitle>
          <DialogContent>
            <TextField
              value={this.state.searchText}
              onChange={this.searchTextChanged}
              placeholder={Localization.strings.INPUT_KEYWORD + "..."}
              onKeyPress={this.handleSearchEnterPressed}
              margin="normal"
              size="small"
              variant="outlined"
            />
            <Tooltip title={Localization.strings.SEARCH}>
              <IconButton
                onClick={this.handleSearchClicked}
              >
                <Icon>search</Icon>
              </IconButton>
            </Tooltip>
            <div>
              Showing result: {this.state.searchOffset+(this.state.images.length > 0? 1:0)}-{this.state.searchOffset + this.state.images.length} / 100
              <IconButton
                onClick={this.previousPageClicked}
                disabled={this.state.searchOffset <= 0 || this.state.images.length == 0}
              >
                <Icon>keyboard_arrow_left</Icon>
              </IconButton>
              <IconButton
                onClick={this.nextPageClicked}
                disabled={this.state.searchOffset >= 90 || this.state.images.length == 0}
              >
                <Icon>keyboard_arrow_right</Icon>
              </IconButton>
            </div>
            <Gallery
              images={this.state.images}
              enableImageSelection={false}
              backdropClosesModal={true}
              preloadNextImage={true}
              enableKeyboardInput={true}
            />
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CANCEL}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default GoogleImageSearchDialog;
